import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "overlay", "destroyInput"]

  toggleDelete(event) {
    event.preventDefault()

    const isMarkedForDeletion = this.destroyInputTarget.value === "1"

    if (isMarkedForDeletion) {
      // Unmark for deletion
      this.destroyInputTarget.value = "0"
      this.overlayTarget.classList.add("hidden")
      this.overlayTarget.classList.remove("flex")
      this.containerTarget.style.opacity = "1"
    } else {
      // Mark for deletion
      this.destroyInputTarget.value = "1"
      this.overlayTarget.classList.remove("hidden")
      this.overlayTarget.classList.add("flex")
      this.containerTarget.style.opacity = "0.5"
    }
  }
}